/**
 * Orchard: PDP color swatch hover hints.
 *
 * Available swatches are handled by CSS hover/focus. Unavailable swatches keep
 * hover/focus for the color hint, while this helper blocks invalid activation.
 */
(function () {
  var activeLabel = null;
  var tooltip = null;
  var swatchSelector = '.product-details .variant-picker .orchard-swatch-circle[data-color-name]';

  function tooltipElement() {
    if (tooltip) return tooltip;

    tooltip = document.createElement('div');
    tooltip.className = 'orchard-swatch-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    document.body.appendChild(tooltip);

    return tooltip;
  }

  function positionTooltip(label) {
    var rect = label.getBoundingClientRect();
    var el = tooltipElement();

    el.textContent = label.dataset.colorName || '';
    el.style.left = rect.left + rect.width / 2 + 'px';
    el.style.top = rect.top - 8 + 'px';
    el.classList.add('is-visible');
  }

  function hideTooltip() {
    if (activeLabel) activeLabel.classList.remove('show-tooltip');
    if (tooltip) tooltip.classList.remove('is-visible');
    activeLabel = null;
  }

  function showTooltip(label) {
    if (label !== activeLabel) {
      hideTooltip();
      activeLabel = label;
      activeLabel.classList.add('show-tooltip');
    }

    positionTooltip(label);
  }

  function disabledSwatchAtPoint(clientX, clientY) {
    var labels = document.querySelectorAll(swatchSelector);

    for (var i = 0; i < labels.length; i += 1) {
      var label = labels[i];
      if (!label.querySelector('input[aria-disabled="true"]')) continue;

      var rect = label.getBoundingClientRect();
      var isInside =
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom;

      if (isInside) return label;
    }

    return null;
  }

  function disabledSwatchFromTarget(target) {
    if (!(target instanceof Element)) return null;

    var label = target.closest(swatchSelector);
    if (!label || !label.querySelector('input[aria-disabled="true"]')) return null;

    return label;
  }

  function preventDisabledActivation(event) {
    var label = disabledSwatchFromTarget(event.target);
    if (!label) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showTooltip(label);
  }

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;

    var label = disabledSwatchAtPoint(event.clientX, event.clientY);
    if (label) {
      showTooltip(label);
    } else {
      hideTooltip();
    }
  });

  document.addEventListener('click', preventDisabledActivation, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    preventDisabledActivation(event);
  }, true);
  document.addEventListener('change', function (event) {
    if (disabledSwatchFromTarget(event.target) && event.target instanceof HTMLInputElement) {
      event.target.checked = false;
    }

    hideTooltip();
  }, true);
  document.addEventListener('pointerleave', hideTooltip);
  document.addEventListener('scroll', hideTooltip, true);
  window.addEventListener('blur', hideTooltip);
})();
